import React, { useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Routes,
  BrowserRouter,
  Navigate,
  Router,
  useLocation,
} from 'react-router-dom';
import { SignIn as SignInView, AccessDenied } from './features';
import { Main as MainLayout, Skeleton as SkeletonLayout } from 'layouts';
import paths from 'routes/index';
import { useMenu, useQuery, useAction } from 'hooks';
import { checkActionPage, checkReportPages } from 'utility';
import AuthService from './components/Auth/Auth.service';
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';



import { useState } from 'react';

const RoutesMain = () => {
  const navigate = useNavigate();
  const uLoc = useLocation();
  const query = useQuery();
  const auth = AuthService.isAuthenticated();
  const [copyPaths, setCopyPath] = useState([...paths]);
  const permission = useMenu();
  const actions = useAction();
  const [isActive, setIsActive] = useState(false);
  const keys = permission;

  useEffect(() => {
    checkRedirect();
  }, []);

  useEffect(() => {
    // کنسل کردن درخواست‌های قبلی هنگام تغییر مسیر
    AuthService.cancelAllPendingRequests();
  }, [navigate]);

  useEffect(() => {
    checkReportPages(actions[1])
    checkActionPage(actions[0]);
  }, [actions]);
  useEffect(() => {
    if (permission && permission.length > 0) {
      setIsActive(true);
    }
  }, [permission]);

  /**
   * در صورتیکه لینک ریدایکرت باشد ، این تابع بررسی میکند و کاربر را به صفحه مورد نظر منتقل میکند
   */
  const checkRedirect = () => {
    if (localStorage.getItem('TOKEN')) {
      // اگه توکن داشته باشه
      if (window.location.pathname === '/sign-in' && String(uLoc?.search).includes('redirectUrl')) {
        let rUrl = String(uLoc.search).replace('?', '').replace('redirectUrl=', '');
        return navigate('/' + rUrl);
      } else if (
        query.get('auto_login_code') &&
        query.get('destination')
      ) {
        return navigate('/sign-in' + uLoc.search);
      } else if (
        window.location.pathname === '/sign-in' &&
        !String(uLoc?.search).includes('redirectUrl')
      ) {
        return navigate('/home');
      }
    } else {
      // اگه توکن نداشته باشه
      if (window.location.pathname === '/sign-in' && String(uLoc?.search).includes('redirectUrl')) {
        let rUrl = String(uLoc.search).replace('?', '').replace('redirectUrl=', '');
        localStorage.setItem('redirectUrl',  (rUrl.startsWith("//") ? "/" + rUrl.slice(2) : rUrl));
        localStorage.setItem('dateTimeRedirect', new Date());
        return navigate('/sign-in');
      }
    }
  };

  return (
    <>
      <SkeletonLayout>
        {!localStorage.getItem('TOKEN') && window.location.pathname != '/sign-in' && (
          <Navigate to="/sign-in" replace />
        )}
        {localStorage.getItem('TOKEN') && window.location.pathname === '/' && (
          <Navigate to="/Home" replace />
        )}
        {localStorage.getItem('TOKEN') &&
          window.location.pathname === '/sign-in' &&
          !uLoc?.search && <Navigate to="/Home" replace />}
        {/* {
          localStorage.getItem('TOKEN') &&
          window.location.pathname === '/sign-in' && uLoc?.search
          && (checkRedirect())
        } */}
        <Routes>
          <Route element={<SignInView />} path="/sign-in" />
        </Routes>

        <MainLayout>
          <Routes>
            {isActive &&
              copyPaths.map((path, index) => {
                if (!path.key || path?.key?.find((elm) => keys?.includes(elm))) {
                  const obj = {
                    path: path.path,
                    element: path.element,
                  };
                  return <Route {...obj} />;
                } else {
                  const obj = {
                    path: path.path,
                    element: <AccessDenied />,
                  };
                  return <Route {...obj} />;
                }
              })}
          </Routes>
          {!isActive && String(uLoc.pathname).toLowerCase() != '/sign-in' && (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
              }}
            >
              <CircularProgress size={24} />
            </div>
          )}
        </MainLayout>
      </SkeletonLayout>
    </>
  );
};
export default RoutesMain;